import React from 'react'
import { NewsletterForm, Page } from 'components/organisms'

import { useTrans } from 'hooks'

const NewsletterTemplate = ({ pagina }) => {
  const t = useTrans()

  return (
    <Page pagina={pagina} topBg="center" className="newsletter-template">
      <div className="newsletter-content">
        <p className="newsletter-content__title">
          {t('Vuoi avere €10 di sconto sul tuo prossimo acquisto?')}
        </p>
        <div
          className="newsletter-content__text"
          dangerouslySetInnerHTML={{
            __html: t(
              'Iscriviti ora alla nostra newsletter e riceverai un buono <b>sconto del valore di €10*.</b><br /> In più potrai rimanere aggiornato su tutte le nostre offerte e iniziative speciali.'
            ),
          }}
        />
        <NewsletterForm className="box" />
        <p className="newsletter-content__disclaimer">
          {t('*Promozione valida per i nuovi clienti per un acquisto minimo di €60')}
        </p>
      </div>
    </Page>
  )
}

export default NewsletterTemplate
